let ROOT = "https://api2.httpiness.com";

export function reportDownloadWin32()
{
    if (!localStorage.getItem("download")) {
        localStorage.setItem("download", true);
        fetch(`${ROOT}/report/download/win32`);
    }

    gtag_report_conversion();
}

export function reportDownloadMacOs()
{
    if (!window.localStorage.getItem("download")) {
        window.localStorage.setItem("download", true);
        fetch(`${ROOT}/report/download/macos`);
    }

    gtag_report_conversion();
}

export function reportHomeVisit()
{
    fetch(`${ROOT}/report/home/visit`);
}

